import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";

export const fileApi = createApi({
  reducerPath: "files",
  baseQuery: createCustomFetchBaseQuery(),
  endpoints: (builder) => ({
    uploadNewFile: builder.mutation({
      query: (fileData) => {
        const formData = new FormData();
        formData.append("file", fileData?.file);
        return {
          url: "file/upload",
          method: "POST",
          body: formData,
        };
      },
      transformResponse: (res) =>res ,
    }),
    getPresignedUrl: builder.mutation({
      query: (fileData) => {
        const data = {
          fileName: fileData?.file?.name,
          fileType: fileData?.file?.type,
        }
        return {
          url: "file/presigned-url",
          method: "POST",
          body: data,
        };
      },
      transformResponse: (res) => res,
    }),
    deleteFile: builder.mutation({
      query: ({fileName}) => ({
        url: `/file/delete`,
        method: "DELETE",
        body: { fileName },
      }),
    }),
  }),
});

export const { useUploadNewFileMutation, useGetPresignedUrlMutation, useDeleteFileMutation } = fileApi;
